import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Location(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 3a6.91 6.91 0 00-4.942 2.096A7.277 7.277 0 005 10.182c0 2.788 1.775 5.501 3.734 7.616A26.283 26.283 0 0012 20.76a26.288 26.288 0 003.266-2.963C17.225 15.683 19 12.97 19 10.182a7.277 7.277 0 00-2.058-5.086A6.91 6.91 0 0012 3zm-.564 19.826c-.455-.312-.89-.654-1.318-1.002a28.272 28.272 0 01-2.852-2.667C5.225 16.953 3 13.757 3 10.182c0-2.428.943-4.761 2.628-6.485A8.91 8.91 0 0112 1c2.394 0 4.686.973 6.372 2.697A9.277 9.277 0 0121 10.182c0 3.575-2.225 6.771-4.266 8.975a28.263 28.263 0 01-2.853 2.667c-.427.348-.862.69-1.316 1.001 0 0-.23.175-.565.175a1 1 0 01-.564-.174zM12 8.455c-.9 0-1.667.752-1.667 1.727 0 .975.768 1.727 1.667 1.727.9 0 1.667-.752 1.667-1.727 0-.975-.768-1.727-1.667-1.727zm-3.667 1.727c0-2.037 1.62-3.727 3.667-3.727 2.046 0 3.667 1.69 3.667 3.727s-1.62 3.727-3.667 3.727c-2.046 0-3.667-1.69-3.667-3.727z",
    clipRule: "evenodd"
  }));
}

export default Location;